// `projects` output — live repositories from the GitHub API.
import React from 'react';
import { relativeTime } from '../../hooks/useGitHub';
import { StarIcon } from './Icons';

const ProjectList = ({ status, repos }) => {
  if (status === 'loading') {
    return <div className="repo-status">Fetching repositories from GitHub…</div>;
  }

  if (status === 'error') {
    return (
      <div className="repo-status">
        Could not reach the GitHub API (it rate-limits at 60 requests/hour).
        <br />
        Browse them directly: <a href="https://github.com/attuulGeriyan" target="_blank" rel="noreferrer">github.com/attuulGeriyan</a>
      </div>
    );
  }

  if (!repos.length) {
    return <div className="repo-status">No public repositories found.</div>;
  }

  return (
    <div className="repo-list">
      <div className="repo-head">
        <span>{repos.length} public repositories</span>
        <span className="repo-head-hint">newest first · live from GitHub</span>
      </div>
      {repos.map((repo) => (
        <a
          key={repo.name}
          className="repo-row"
          href={repo.url}
          target="_blank"
          rel="noreferrer"
        >
          <div className="repo-row-top">
            <span className="repo-name">{repo.name}</span>
            {repo.language && <span className="repo-lang">{repo.language}</span>}
            {repo.stars > 0 && (
              <span className="repo-stars"><StarIcon /> {repo.stars}</span>
            )}
            <span className="repo-pushed">{relativeTime(repo.pushedAt)}</span>
          </div>
          {repo.description && <div className="repo-desc">{repo.description}</div>}
        </a>
      ))}
    </div>
  );
};

export default ProjectList;
